export function getErrorMessage(error: Error): string {
  const msg = error.message.toLowerCase();

  // Permission errors
  if (
    msg.includes("only admins and owners") ||
    msg.includes("permission denied") ||
    msg.includes("insufficient privileges")
  ) {
    return "You do not have permission to perform this action";
  }

  // Member removal errors (check first for specific "member" keywords)
  if (msg.includes("cannot remove owner")) {
    return "Cannot remove owner from tenant";
  }
  if (msg.includes("cannot remove yourself")) {
    return "Cannot remove yourself from tenant";
  }
  if (msg.includes("member not found")) {
    return "Member not found";
  }
  if (msg.includes("member is already deleted")) {
    return "Member has already been removed";
  }

  // Token errors (check before generic "not found")
  if (msg.includes("token-not-found") || msg.includes("token not found")) {
    return "Token not found";
  }
  if (msg.includes("token-revoked") || msg.includes("token has been revoked")) {
    return "Token has already been revoked";
  }
  if (msg.includes("token-expired") || msg.includes("token has expired")) {
    return "Token has expired";
  }
  if (msg.includes("token-invalid") || msg.includes("invalid token")) {
    return "Invalid token format";
  }

  // Invitation errors
  if (msg.includes("already exists") || msg.includes("duplicate")) {
    return "User already invited";
  }
  if (msg.includes("already a member")) {
    return "User is already a member";
  }
  if (msg.includes("invalid email")) {
    return "Invalid email format";
  }
  if (msg.includes("cannot resend expired")) {
    return "Cannot resend expired invitation";
  }
  if (msg.includes("already accepted")) {
    return "Cannot resend already accepted invitation";
  }
  if (msg.includes("cannot revoke expired")) {
    return "Cannot revoke expired invitation";
  }
  if (msg.includes("cannot revoke accepted")) {
    return "Cannot revoke already accepted invitation";
  }
  // Generic "not found" check (must come after specific checks)
  if (msg.includes("not found") || msg.includes("does not belong")) {
    return "Resource not found";
  }

  // Network errors
  if (msg.includes("network") || msg.includes("fetch failed")) {
    return "Network error. Please check your connection.";
  }

  return "An error occurred. Please try again.";
}
